import { render, staticRenderFns } from "./Spac.vue?vue&type=template&id=4508c1e3&scoped=true&"
import script from "./Spac.vue?vue&type=script&lang=js&"
export * from "./Spac.vue?vue&type=script&lang=js&"
import style0 from "./Spac.vue?vue&type=style&index=0&id=4508c1e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4508c1e3",
  null
  
)

export default component.exports